// Deadlines are calendar dates stored at UTC midnight, not local instants.
export const deadlineDate = (value) => value ? String(value).slice(0, 10) : "";
export const formatDeadline = (value) => {
  const date = deadlineDate(value);
  if (!date) return "";
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

export const sortTasks = (tasks, mode = "manual", reversed = false) => [...tasks].sort((a, b) => {
  const direction = reversed ? -1 : 1;
  const manual = (Number(a.position) || 0) - (Number(b.position) || 0) || a.id - b.id;
  if (mode === "title") return direction * (a.title.localeCompare(b.title, undefined, { sensitivity: "base" }) || manual);
  if (mode === "deadline") {
    const first = deadlineDate(a.deadline);
    const second = deadlineDate(b.deadline);
    if (!first && second) return 1;
    if (first && !second) return -1;
    return direction * (first.localeCompare(second) || manual);
  }
  return direction * manual;
});
